import { useForm, yupResolver } from '@mantine/form'
import { GetInputProps } from '@mantine/form/lib/types'
import { useAppNavigation } from '@v2/domains/routing/hooks/useAppNavigation.hook'
import { useAppDispatch } from '@v2/store/hooks'
import * as yup from 'yup'

import { SignInDtoV3 } from 'src/api/generated'

import { authApiEndpoints, useLoginMutation } from '../api/auth.api'

interface IUseLoginFormUseCase {
  getFormProps: GetInputProps<SignInDtoV3>
  onSubmit: () => void
  loginMutationStatus: {
    isLoading: boolean
    isSuccess: boolean
  }
}

const useLoginForm = (): IUseLoginFormUseCase => {
  const dispatch = useAppDispatch()
  const [login, { isLoading, isSuccess }] = useLoginMutation()
  const { navigateTo } = useAppNavigation()

  const schema = yup.object().shape({
    email: yup.string().required('Required').email('Invalid email'),
    password: yup.string().required('Required').min(8, 'At least 8 characters'),
  })

  const form = useForm<SignInDtoV3>({
    mode: 'uncontrolled',
    initialValues: {
      email: '',
      password: '',
    },
    validateInputOnBlur: true,
    validate: yupResolver(schema),
  })

  const onSubmit = () => {
    form.onSubmit(async (values) => {
      const response = await login(values)
        .unwrap()
        .catch((error) => {
          form.setErrors({ password: error?.data?.message ?? 'Error' })
        })

      await dispatch(
        authApiEndpoints.getOrganizationsByUserId.initiate(
          response?.userId ?? '',
          {
            forceRefetch: true,
          },
        ),
      ).unwrap()

      navigateTo('SELECT_ORGANIZATION')
    })()
  }

  return {
    getFormProps: form.getInputProps,
    onSubmit: onSubmit,
    loginMutationStatus: {
      isLoading: isLoading,
      isSuccess: isSuccess,
    },
  }
}

export default useLoginForm
